<template>
  <el-dialog
    :visible="showPopup"
    :fullscreen="true"
    :append-to-body="true"
    :modal="false"
    top="0"
    custom-class="preview-text-dialog"
    @close="emitClose">
    <h5>
      Country: {{choosenCountry}}<br>
      Language: {{choosenLanguage}}<br>
      File: {{textFile}}<br>
    </h5>
    <div class="textPreview">
      <!-- eslint-disable -->
      <span v-if="completeHtmlBuild">
        <div v-for="(item, index) in completeHtmlBuild" :key="index">
          <span v-if="item.h1"><h1 v-html="item.h1"></h1></span>
          <span v-if="item.foreword"><p v-html="item.foreword"></p></span>
          <span v-if="item.afterword"><p v-html="item.afterword"></p></span>
          <span v-if="item.segments">
            <span v-for="(segment, index) in item.segments" :key="index" >
              <span v-if="segment.h1"><h1 v-html="segment.h1"></h1></span>
              <span v-if="segment.h2"><h2 v-html="segment.h2"></h2></span>
              <span v-if="segment.summary"><p v-html="segment.summary"></p></span>
              <span v-if="segment.content"><p v-html="segment.content"></p></span>
              <span v-if="segment.consent"><p v-html="segment.consent"></p></span>
            </span>
          </span>
        </div>
      </span>
      <!-- eslint-enable -->
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: [
    'choosenCountry',
    'choosenLanguage',
    'showPreview',
    'textFile',
    'valueHtml',
  ],
  computed: {
    completeHtmlBuild() {
      return this.valueHtml;
    },
    showPopup: {
      get() {
        return this.showPreview;
      },
      set(newValue) {
        this.showPopup = newValue;
      },
    },
  },
  methods: {
    emitClose() {
      this.$store.commit('openTextPreview', false);
    },
  },
};
</script>

<style lang="scss">
.preview-text-dialog {
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0px 20px;
  }
}
</style>
